//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Header, MobileMenu } from '@cmp/common';
import {
  Banner,
  CreateAccount,
  AuthSection,
  BenefitSection,
  QuestionSection,
} from './components';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { ScreenSet, showScreenSet } from '@helpers/gigya';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import { removeEmptyAddresses, addTogglePasswordSwitch } from '@helpers/gigya';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };

    this.handleToggle = this.handleToggle.bind(this);
  }
  componentDidMount() {
    const {
      storeConfig: { language },
    } = this.context;
    showScreenSet(
      language,
      {
        ...ScreenSet.SignIn,
        events: {
          onAfterScreenLoad: (e) => {
            document
              .getElementById('login-container')
              .querySelectorAll('.gigya-input-text,.gigya-input-password')
              .forEach((nodeInput) => {
                nodeInput.addEventListener('keyup', (event) => {
                  window.interactiveLabel(event);
                });
              });
            removeEmptyAddresses(e);
            addTogglePasswordSwitch();
          },
        },
      },
      'login-container'
    );
  }

  handleToggle() {
    this.setState({ toggle: !this.state.toggle });
  }

  render() {
    const { t } = this.props;
    const { toggle } = this.state;
    const { handleToggle } = this;
    const componentClasses = classNames(styles.Landing);
    return (
      <div className={componentClasses}>
        <Header toggle={toggle} onToggle={handleToggle} />
        <div className={styles.Content}>
          {toggle ? (
            <div className={styles.ContentMobile}>
              <MobileMenu />
            </div>
          ) : (
            <div className={styles.ContentDesktop}>
              <Banner />
              <AuthSection />
              <BenefitSection />
              {t('trust_arc_locale') !== 'ja' ? (
                <QuestionSection />
              ) : (
                <div></div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Landing);
Landing.contextType = StoreConfigContext;
